export const FLUX_VERSION = (typeof process !== "undefined" ? process.env?.FLUX_VERSION : "") ?? "";
//# sourceMappingURL=fluxMeta.js.map